import {
  Components,
  formHelperTextClasses,
  inputBaseClasses,
  Theme,
} from '@mui/material';

export function getMuiTextField(theme: Theme): Components['MuiTextField'] {
  return {
    defaultProps: {
      variant: 'filled',
    },
    styleOverrides: {
      root: {
        [`&:has(.${inputBaseClasses.multiline})`]: {
          [`.${formHelperTextClasses.root}`]: {
            marginTop: theme.spacing(2),
          },
        },
      },
    },
  };
}
